var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "form-item-wrapper",
        {
          attrs: {
            designer: _vm.designer,
            field: _vm.field,
            rules: _vm.rules,
            "design-state": _vm.designState,
            "parent-widget": _vm.parentWidget,
            "parent-list": _vm.parentList,
            "index-of-parent-list": _vm.indexOfParentList,
            "sub-form-row-index": _vm.subFormRowIndex,
            "sub-form-col-index": _vm.subFormColIndex,
            "sub-form-row-id": _vm.subFormRowId,
          },
        },
        [
          _c(_vm.name, {
            ref: "selectMember",
            tag: "component",
            attrs: { "only-one": true, id: _vm.field.options.fieldId },
            on: {
              getSelectList: _vm.getSelectList,
              changeMastart: _vm.setReferRecord,
              getSelection: _vm.getSelection,
            },
            scopedSlots: _vm._u([
              {
                key: "custom",
                fn: function () {
                  return [
                    _c("el-input", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.getReadMode(),
                          expression: "!getReadMode()",
                        },
                      ],
                      ref: "fieldEditor",
                      staticClass: "hide-spin-button",
                      attrs: {
                        disabled: _vm.field.options.disabled,
                        readonly: "",
                        clearable: "",
                        size: _vm.field.options.size,
                        type: "text",
                        placeholder: _vm.field.options.placeholder,
                        "prefix-icon": _vm.field.options.prefixIcon,
                        "suffix-icon": _vm.field.options.suffixIcon,
                      },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.onAppendButtonClick($event)
                        },
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "suffix",
                          fn: function () {
                            return [
                              !!_vm.displayValue && !_vm.field.options.disabled
                                ? _c("i", {
                                    staticClass:
                                      "el-input__icon el-icon-circle-close",
                                    attrs: { title: "清除" },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.handleClearEvent($event)
                                      },
                                    },
                                  })
                                : _vm._e(),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                      model: {
                        value: _vm.displayValue,
                        callback: function ($$v) {
                          _vm.displayValue = $$v
                        },
                        expression: "displayValue",
                      },
                    }),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
          _vm._v(" "),
          _vm.getReadMode()
            ? [
                _c("div", { staticClass: "readonly-mode-field" }, [
                  _vm._v(_vm._s(_vm.contentForReadMode)),
                ]),
              ]
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }